import { render } from "./InterestInLivingAbroad.vue?vue&type=template&id=4ba39750"
import script from "./InterestInLivingAbroad.vue?vue&type=script&lang=js"
export * from "./InterestInLivingAbroad.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__